export const enum AppType {
	Internal = "Internal",
}

export function parseAppType(value: string | null | undefined): AppType | null {
	if (value === AppType.Internal) {
		return value;
	}
	return null;
}
